import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _badge = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    icon: '_image',
};
var _createBadgeRequest = { badge: '_badge' };
var _createBadgeResponse = { badge: '_badge' };
var _deleteBadgeRequest = {};
var _deleteBadgeResponse = {};
var _getBadgeRequest = {};
var _getBadgeResponse = { badge: '_badge' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listBadgesRequest = {};
var _listBadgesResponse = { badges: '_badge' };
var _queryBadgesRequest = {};
var _queryBadgesResponse = { badges: '_badge' };
var _updateBadgeRequest = { badge: '_badge' };
var _updateBadgeResponse = { badge: '_badge' };
var _updateBadgesDisplayOrderRequest = {};
var _updateBadgesDisplayOrderResponse = { badges: '_badge' };
function resolveWixBadgesV4BadgesUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/members/v4/badges',
                destPath: '/v4/badges',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new Badge. */
export function createBadge(payload) {
    var _a = serializer(_createBadgeRequest, {
        _badge: _badge,
        _image: _image,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBadgeResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __createBadge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'POST',
            methodFqn: 'wix.badges.v4.Badges.CreateBadge',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBadge.fromReq = fromReq;
    __createBadge.__isAmbassador = true;
    return __createBadge;
}
/** Retrieves a Badge. */
export function getBadge(payload) {
    var _a = serializer(_getBadgeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBadgeResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __getBadge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'GET',
            methodFqn: 'wix.badges.v4.Badges.GetBadge',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges/{badgeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBadge.fromReq = fromReq;
    __getBadge.__isAmbassador = true;
    return __getBadge;
}
/**
 * Retrieves up to 1000 badges, given the requested paging.
 * Default `paging.limit` is 100, `paging.offset` - 0.
 * For more information, see
 * [API Query Language: The Paging Section]
 * (https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-paging-section).
 */
export function listBadges(payload) {
    var _a = serializer(_listBadgesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listBadgesResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __listBadges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'GET',
            methodFqn: 'wix.badges.v4.Badges.ListBadges',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listBadges.fromReq = fromReq;
    __listBadges.__isAmbassador = true;
    return __listBadges;
}
/**
 * Retrieves up to 1000 badges, given the requested query options, paging, and sorting.
 * Default `paging.limit` is 100, `paging.offset` - 0.
 * For more information, see
 * [API Query Language: The Paging Section](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-paging-section).
 */
export function queryBadges(payload) {
    var _a = serializer(_queryBadgesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBadgesResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __queryBadges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'POST',
            methodFqn: 'wix.badges.v4.Badges.QueryBadges',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBadges.fromReq = fromReq;
    __queryBadges.__isAmbassador = true;
    return __queryBadges;
}
/** Updates a badge's specified properties. */
export function updateBadge(payload) {
    var _a = serializer(_updateBadgeRequest, {
        _badge: _badge,
        _image: _image,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBadgeResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __updateBadge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'PATCH',
            methodFqn: 'wix.badges.v4.Badges.UpdateBadge',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges/{badge.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBadge.fromReq = fromReq;
    __updateBadge.__isAmbassador = true;
    return __updateBadge;
}
/** Deletes a badge. */
export function deleteBadge(payload) {
    var _a = serializer(_deleteBadgeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBadgeResponse, {}).fromJSON;
    function __deleteBadge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'DELETE',
            methodFqn: 'wix.badges.v4.Badges.DeleteBadge',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges/{badgeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBadge.fromReq = fromReq;
    __deleteBadge.__isAmbassador = true;
    return __deleteBadge;
}
/** Updates badges' display order. */
export function updateBadgesDisplayOrder(payload) {
    var _a = serializer(_updateBadgesDisplayOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBadgesDisplayOrderResponse, {
        _badge: _badge,
        _image: _image,
    }).fromJSON;
    function __updateBadgesDisplayOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.badges.v4.badge',
            method: 'POST',
            methodFqn: 'wix.badges.v4.Badges.UpdateBadgesDisplayOrder',
            url: resolveWixBadgesV4BadgesUrl({
                protoPath: '/v4/badges/order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBadgesDisplayOrder.fromReq = fromReq;
    __updateBadgesDisplayOrder.__isAmbassador = true;
    return __updateBadgesDisplayOrder;
}
//# sourceMappingURL=http.impl.js.map